import { Floor } from "shared/types/Floor"
import { ProductPosition } from "shared/types/ProductPosition"
import {
  isProjectProductPosition,
  isProjectProductPositionAddon
} from "shared/types/Project"
import { Room } from "shared/types/Room"
import { ProductPositionAddon } from "shared/types/__generated__/graphql"
import { getDepth } from "shared/ui/table/utils/getDepth"

export function getProductPositionTablePositionDepth(
  item: ProductPositionAddon | ProductPosition | Room | Floor
): number {
  if (isProjectProductPositionAddon(item) || isProjectProductPosition(item)) {
    return 1
  }
  return Math.max(getDepth(item), 2)
}
